var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
var defaultOptions = {};
export var AccessPlaceType = {
    Campus: 'CAMPUS',
    Level: 'LEVEL',
    Location: 'LOCATION',
    Organization: 'ORGANIZATION',
    Space: 'SPACE'
};
export var AddMeetingServiceErrorResponseReason = {
    CategoryMissing: 'CATEGORY_MISSING',
    /** This meeting service has kind=SPACE_REQUEST_FORM, and one of the desired spaces already has a request form */
    SpaceAlreadyHasRequestForm: 'SPACE_ALREADY_HAS_REQUEST_FORM'
};
export var AddMeetingServicesCategoryErrorReason = {
    NameIsNotUnique: 'NAME_IS_NOT_UNIQUE'
};
export var AnnouncementPriorityStatus = {
    Priority: 'PRIORITY',
    Standard: 'STANDARD'
};
export var AnnouncementStatus = {
    Active: 'ACTIVE',
    Archived: 'ARCHIVED',
    Scheduled: 'SCHEDULED'
};
export var ApproveMeetingServiceRequestErrorReason = {
    Conflict: 'CONFLICT'
};
export var AuthContextAccountUserRole = {
    Admin: 'ADMIN',
    Member: 'MEMBER',
    Owner: 'OWNER'
};
export var AuthContextAppScope = {
    BasicRead: 'BASIC_READ',
    BasicWrite: 'BASIC_WRITE',
    Privileged: 'PRIVILEGED'
};
export var AuthContextOrganizationScope = {
    BasicRead: 'BASIC_READ',
    BasicWrite: 'BASIC_WRITE'
};
export var Availability = {
    /** Currently available */
    Available: 'AVAILABLE',
    /** Resource has been booked */
    Booked: 'BOOKED',
    /** Resource marked as unavailable for booking */
    Unavailable: 'UNAVAILABLE',
    /** Resource marked as unknown due to desk inexistence */
    Unknown: 'UNKNOWN'
};
export var BookingPolicyType = {
    /** Indicate the desk may be indefinitely assigned to a particular user. */
    Assigned: 'ASSIGNED',
    /** Indicate that the desk is available to be booked for short term use. */
    Hot: 'HOT',
    /** Indicate that the desk may be reserved for a defined period duration. */
    Hoteled: 'HOTELED',
    /** Indicate that the desk may be reverse hoteled on an excluded assigned reservation. */
    ReverseHotel: 'REVERSE_HOTEL',
    /** Indicate that more people can be assigned to a single desk. Only used in combination with either ASSIGNED or HOTELED types */
    Shared: 'SHARED'
};
export var BookingStatus = {
    ApprovalRequired: 'APPROVAL_REQUIRED',
    Assigned: 'ASSIGNED',
    NonReservable: 'NON_RESERVABLE',
    OnDemand: 'ON_DEMAND',
    Reservable: 'RESERVABLE'
};
export var BookingType = {
    ApprovalRequired: 'APPROVAL_REQUIRED',
    Assigned: 'ASSIGNED',
    NonReservable: 'NON_RESERVABLE',
    OnDemand: 'ON_DEMAND',
    Reservable: 'RESERVABLE'
};
export var BookingWindowPolicyTargetType = {
    Level: 'LEVEL',
    Zone: 'ZONE'
};
export var BrivoTenancy = {
    Eu: 'EU',
    Us: 'US'
};
export var BuildingGeofenceGeoJsonGeometryType = {
    Point: 'Point'
};
export var CalendarHealthEnum = {
    /** Calendar is functioning correctly */
    Healthy: 'HEALTHY',
    /** Calendar has sync or other issues */
    Unhealthy: 'UNHEALTHY'
};
export var ChangeAnswersOnMeetingServiceRequestErrorReason = {
    Conflict: 'CONFLICT'
};
export var ClientType = {
    DashboardWeb: 'DASHBOARD_WEB',
    Kiosk: 'KIOSK',
    Other: 'OTHER',
    RobinMobile: 'ROBIN_MOBILE'
};
/** Completed onboarding step identifiers; stored as slugs in the org setting. */
export var CompletedOnboardingStep = {
    AddResources: 'ADD_RESOURCES',
    AddUsers: 'ADD_USERS',
    CreateBuildings: 'CREATE_BUILDINGS',
    EnableIntegrations: 'ENABLE_INTEGRATIONS',
    InviteAdmins: 'INVITE_ADMINS',
    ManageOrganization: 'MANAGE_ORGANIZATION',
    UploadLogo: 'UPLOAD_LOGO',
    UploadMaps: 'UPLOAD_MAPS'
};
export var ConfirmationClientType = {
    Badge: 'BADGE',
    DashboardWeb: 'DASHBOARD_WEB',
    Kiosk: 'KIOSK',
    Other: 'OTHER',
    QrScan: 'QR_SCAN',
    RobinMobile: 'ROBIN_MOBILE',
    Slack: 'SLACK',
    Teams: 'TEAMS',
    Wifi: 'WIFI'
};
export var ConfirmationMethod = {
    Local: 'LOCAL',
    Remote: 'REMOTE'
};
export var CustomFieldType = {
    LongText: 'LONG_TEXT',
    ShortText: 'SHORT_TEXT',
    SingleSelect: 'SINGLE_SELECT'
};
export var CustomVisitFormOrderByField = {
    FormName: 'FormName',
    NumberOfLinkedLocations: 'NumberOfLinkedLocations',
    UpdatedAt: 'UpdatedAt'
};
export var Device_Type = {
    Unknown: 'UNKNOWN',
    VisitorArrival: 'VISITOR_ARRIVAL',
    VisitorBadgePrinter: 'VISITOR_BADGE_PRINTER'
};
export var DayOfWeek = {
    Friday: 'FRIDAY',
    Monday: 'MONDAY',
    Saturday: 'SATURDAY',
    Sunday: 'SUNDAY',
    Thursday: 'THURSDAY',
    Tuesday: 'TUESDAY',
    Wednesday: 'WEDNESDAY'
};
export var DeleteMeetingServicesCategoryErrorResponseReason = {
    /** The category has meeting services associated with it and cannot be deleted */
    HasServices: 'HAS_SERVICES'
};
export var DeliveriesOrderByField = {
    CreatedAt: 'createdAt',
    DeliveryZoneName: 'deliveryZoneName',
    LastNotifiedAt: 'lastNotifiedAt',
    RecipientName: 'recipientName',
    Status: 'status'
};
export var DeliveryStatus = {
    Pending: 'PENDING',
    PickedUp: 'PICKED_UP',
    UnknownRecipient: 'UNKNOWN_RECIPIENT',
    WrongRecipient: 'WRONG_RECIPIENT'
};
export var DeliveryTextType = {
    PhotoRecognizer: 'PhotoRecognizer'
};
export var DeskConfirmationStatus = {
    /** Desk reservation cannot be confirmed */
    CannotConfirm: 'CANNOT_CONFIRM',
    /** Desk reservation has been confirmed */
    Confirmed: 'CONFIRMED',
    /** Desk reservation has been declined */
    Declined: 'DECLINED',
    /** Desk reservation has not been confirmed */
    Unconfirmed: 'UNCONFIRMED'
};
export var DeskConfirmationType = {
    Compass: 'Compass',
    Dashboard: 'Dashboard',
    DoorBadgeSwipe: 'DoorBadgeSwipe',
    Email: 'Email',
    Geofence: 'Geofence',
    Ip: 'IP',
    Nfc: 'NFC',
    Qr: 'QR',
    Slack: 'Slack',
    Teams: 'Teams'
};
export var DeskFilters = {
    Disabled: 'DISABLED',
    Enabled: 'ENABLED'
};
export var DeskReservationVisibility = {
    Everyone: 'EVERYONE',
    JustMe: 'JUST_ME'
};
export var DeskType = {
    Assigned: 'assigned',
    Hot: 'hot',
    Hoteled: 'hoteled',
    Shared: 'shared'
};
export var DeskUnbookableReasonType = {
    BookingWindowPolicy: 'BOOKING_WINDOW_POLICY',
    LackingPermissions: 'LACKING_PERMISSIONS',
    MaxCapacityReached: 'MAX_CAPACITY_REACHED',
    NoAccess: 'NO_ACCESS',
    ScheduleViolated: 'SCHEDULE_VIOLATED',
    SeatReservationAdvancedBookingThreshold: 'SEAT_RESERVATION_ADVANCED_BOOKING_THRESHOLD',
    SeatReservationMaxLength: 'SEAT_RESERVATION_MAX_LENGTH',
    SeatReservationRecurrenceAllowed: 'SEAT_RESERVATION_RECURRENCE_ALLOWED',
    SeatReservationWorkingHoursRestricted: 'SEAT_RESERVATION_WORKING_HOURS_RESTRICTED',
    Unknown: 'UNKNOWN',
    ViolateHotDeskPolicy: 'VIOLATE_HOT_DESK_POLICY'
};
export var DeviceFeatureFlagType = {
    /** Feature flag for enabling badge printing from an arrival display */
    ArrivalDisplayBadgePrinting: 'ARRIVAL_DISPLAY_BADGE_PRINTING',
    /** Enables using custom visit types on devices like the Arrival Display or GuestUI */
    CustomVisitTypes: 'CUSTOM_VISIT_TYPES',
    /** Language selection feature flag for project global */
    LanguageSelectionEnabled: 'LANGUAGE_SELECTION_ENABLED',
    /** Language selection feature flag for a location global */
    LocationLanguageSelectionEnabled: 'LOCATION_LANGUAGE_SELECTION_ENABLED',
    /** Enables the ability to capture images to be used on visitor badges */
    VisitorBadgeImages: 'VISITOR_BADGE_IMAGES'
};
export var DeviceStatus = {
    Offline: 'OFFLINE',
    Online: 'ONLINE',
    Unknown: 'UNKNOWN'
};
export var DeviceStatusInput = {
    Offline: 'OFFLINE',
    Online: 'ONLINE'
};
export var DistributionService = {
    Email: 'EMAIL',
    Slack: 'SLACK',
    Teams: 'TEAMS'
};
export var DraftAccessLevel = {
    Collaborator: 'collaborator',
    Editor: 'editor',
    Viewer: 'viewer'
};
export var DraftAuditEntityType = {
    Collaborator: 'COLLABORATOR',
    Desk: 'DESK',
    Draft: 'DRAFT',
    Neighborhood: 'NEIGHBORHOOD',
    Queue: 'QUEUE',
    Settings: 'SETTINGS',
    UserAssignment: 'USER_ASSIGNMENT'
};
export var DraftAuditLogSortOrder = {
    Asc: 'ASC',
    Desc: 'DESC'
};
export var DraftAuditOperationType = {
    DesksAddedToNeighborhood: 'DESKS_ADDED_TO_NEIGHBORHOOD',
    DesksRemovedFromNeighborhood: 'DESKS_REMOVED_FROM_NEIGHBORHOOD',
    DeskAvailabilityChanged: 'DESK_AVAILABILITY_CHANGED',
    DeskTypeChanged: 'DESK_TYPE_CHANGED',
    DraftAccessLevelChanged: 'DRAFT_ACCESS_LEVEL_CHANGED',
    DraftCollaboratorRemoved: 'DRAFT_COLLABORATOR_REMOVED',
    DraftCreated: 'DRAFT_CREATED',
    DraftDiscarded: 'DRAFT_DISCARDED',
    DraftEmailsSentToAffectedUsers: 'DRAFT_EMAILS_SENT_TO_AFFECTED_USERS',
    DraftLockStatusChanged: 'DRAFT_LOCK_STATUS_CHANGED',
    DraftPublished: 'DRAFT_PUBLISHED',
    DraftRenamed: 'DRAFT_RENAMED',
    DraftShared: 'DRAFT_SHARED',
    DraftShowNeighborhoodColorSettingUpdated: 'DRAFT_SHOW_NEIGHBORHOOD_COLOR_SETTING_UPDATED',
    NeighborhoodColorChanged: 'NEIGHBORHOOD_COLOR_CHANGED',
    NeighborhoodCreated: 'NEIGHBORHOOD_CREATED',
    NeighborhoodRemoved: 'NEIGHBORHOOD_REMOVED',
    NeighborhoodRenamed: 'NEIGHBORHOOD_RENAMED',
    UserAssignedToDesk: 'USER_ASSIGNED_TO_DESK',
    UserUnassignedFromDesk: 'USER_UNASSIGNED_FROM_DESK'
};
export var DraftCollaboratorAccessLevel = {
    Collaborator: 'collaborator',
    Viewer: 'viewer'
};
export var DraftConflictEntityType = {
    Desk: 'desk'
};
export var DraftConflictReason = {
    DeskDeleted: 'desk_deleted',
    SnapshotLiveMismatch: 'snapshot_live_mismatch',
    UserDeleted: 'user_deleted'
};
export var DraftConflictType = {
    Actionable: 'actionable',
    Informative: 'informative'
};
export var DraftOrderByValues = {
    CreatedAt: 'createdAt',
    CreatedBy: 'createdBy',
    FloorName: 'floorName',
    Name: 'name',
    Status: 'status',
    Type: 'type',
    UpdatedAt: 'updatedAt',
    UpdatedBy: 'updatedBy'
};
export var DraftScope = {
    Building: 'building',
    Floor: 'floor'
};
export var DraftSettingsName = {
    Assignments: 'ASSIGNMENTS',
    Conflicts: 'CONFLICTS',
    Default: 'DEFAULT',
    Disposable: 'DISPOSABLE',
    DraftScope: 'DRAFT_SCOPE',
    Layout: 'LAYOUT',
    Neighborhoods: 'NEIGHBORHOODS'
};
export var DraftStatus = {
    Discarded: 'discarded',
    Open: 'open',
    Published: 'published',
    Publishing: 'publishing',
    PublishingFailed: 'publishing_failed'
};
export var EditMeetingServicesCategoryErrorResponseReason = {
    CategoryMissing: 'CATEGORY_MISSING',
    NameIsNotUnique: 'NAME_IS_NOT_UNIQUE'
};
export var EmployeeVisitConfirmationStatus = {
    Canceled: 'CANCELED',
    Confirmed: 'CONFIRMED',
    Unknown: 'UNKNOWN'
};
export var EmployeeVisitFilterSetting = {
    ActiveOnly: 'ACTIVE_ONLY',
    All: 'ALL',
    CancelledOnly: 'CANCELLED_ONLY'
};
export var EmployeeVisitStatus = {
    Cancelled: 'CANCELLED',
    Confirmed: 'CONFIRMED',
    Unconfirmed: 'UNCONFIRMED'
};
export var EntityType = {
    Desk: 'DESK',
    Neighborhood: 'NEIGHBORHOOD'
};
/** Enum for actor types that can perform operations on events */
export var EventAuditLogActorType = {
    App: 'APP',
    Device: 'DEVICE',
    Organization: 'ORGANIZATION',
    Unknown: 'UNKNOWN',
    User: 'USER'
};
/** Enum for event field types that can be changed */
export var EventAuditLogFieldType = {
    CreatedAt: 'CREATED_AT',
    CreationType: 'CREATION_TYPE',
    CreatorEmail: 'CREATOR_EMAIL',
    CreatorId: 'CREATOR_ID',
    Description: 'DESCRIPTION',
    EndedAt: 'ENDED_AT',
    EndedAtTimezone: 'ENDED_AT_TIMEZONE',
    IsAllDay: 'IS_ALL_DAY',
    Location: 'LOCATION',
    OrganizerEmail: 'ORGANIZER_EMAIL',
    OrganizerId: 'ORGANIZER_ID',
    Recurrence: 'RECURRENCE',
    RecurrenceId: 'RECURRENCE_ID',
    RemoteCalendarMailboxAddress: 'REMOTE_CALENDAR_MAILBOX_ADDRESS',
    RemoteEventId: 'REMOTE_EVENT_ID',
    RemoteSeriesId: 'REMOTE_SERIES_ID',
    RemoteType: 'REMOTE_TYPE',
    Sequence: 'SEQUENCE',
    SeriesId: 'SERIES_ID',
    ShowAs: 'SHOW_AS',
    SpaceId: 'SPACE_ID',
    StartedAt: 'STARTED_AT',
    StartedAtTimezone: 'STARTED_AT_TIMEZONE',
    Status: 'STATUS',
    Title: 'TITLE',
    Uid: 'UID',
    Visibility: 'VISIBILITY'
};
export var EventAuditLogInviteeFieldType = {
    ResponseStatus: 'RESPONSE_STATUS'
};
/** Enum for operations that can be performed on events */
export var EventAuditLogOperation = {
    ApproveSpaceReservationRequest: 'APPROVE_SPACE_RESERVATION_REQUEST',
    Cancel: 'CANCEL',
    Confirm: 'CONFIRM',
    Create: 'CREATE',
    Delete: 'DELETE',
    DenySpaceReservationRequest: 'DENY_SPACE_RESERVATION_REQUEST',
    SyncCancel: 'SYNC_CANCEL',
    SyncCreate: 'SYNC_CREATE',
    SyncDelete: 'SYNC_DELETE',
    SyncUpdate: 'SYNC_UPDATE',
    Unconfirm: 'UNCONFIRM',
    Update: 'UPDATE'
};
export var EventCreationType = {
    Automatic: 'AUTOMATIC',
    Manual: 'MANUAL',
    Proxied: 'PROXIED',
    Synced: 'SYNCED',
    Unknown: 'UNKNOWN'
};
export var EventParticipationRole = {
    Chair: 'CHAIR',
    NonParticipant: 'NON_PARTICIPANT',
    Optional: 'OPTIONAL',
    Required: 'REQUIRED',
    Unknown: 'UNKNOWN'
};
export var EventResponseStatus = {
    Accepted: 'ACCEPTED',
    Declined: 'DECLINED',
    Delegated: 'DELEGATED',
    NotResponded: 'NOT_RESPONDED',
    Tentative: 'TENTATIVE',
    Unknown: 'UNKNOWN'
};
export var EventUpdateFailReasons = {
    LackingEventUpdatePermissions: 'LACKING_EVENT_UPDATE_PERMISSIONS',
    SpaceDeclined: 'SPACE_DECLINED',
    SpaceUnavailable: 'SPACE_UNAVAILABLE',
    Unknown: 'UNKNOWN'
};
/** External account integration types. */
export var ExternalAccountType = {
    Google: 'GOOGLE',
    MicrosoftGraph: 'MICROSOFT_GRAPH'
};
export var FeatureFlagType = {
    /** Enables category images for activities */
    ActivitiesCategoryImagesSupport: 'ACTIVITIES_CATEGORY_IMAGES_SUPPORT',
    /** Enable Chat Functionality on Activities */
    ActivityChat: 'ACTIVITY_CHAT',
    /** Enables add a space modal on web */
    AddSpaceModalWeb: 'ADD_SPACE_MODAL_WEB',
    /** Enables the ui for the auto desk booking for employee and admin */
    AutoDeskBooking: 'AUTO_DESK_BOOKING',
    /** Enables the ui for booking multiples days in a week */
    BookDeskAhead: 'BOOK_DESK_AHEAD',
    /** Enables the bulk map uploads */
    BulkMapUploads: 'BULK_MAP_UPLOADS',
    /** Feature sends out notifications out when a calendar integration or space calendars are detected to be in a bad state */
    CalendarHealthNotifications: 'CALENDAR_HEALTH_NOTIFICATIONS',
    /** Enables the schedule Information tab for campus app */
    CampusApp: 'CAMPUS_APP',
    /** New booking flow */
    ConsolidatedBookingFlow: 'CONSOLIDATED_BOOKING_FLOW',
    /** Enables creating, editing, and using custom fields for guest visits */
    CustomVisitFields: 'CUSTOM_VISIT_FIELDS',
    /** Enables adding/removing custom visit types */
    CustomVisitTypes: 'CUSTOM_VISIT_TYPES',
    /** Enables the create org functionality in the dashboard apps project */
    DashboardAppsCreateOrganization: 'DASHBOARD_APPS_CREATE_ORGANIZATION',
    /** Allow user to view the new onboarding flow */
    DashboardAppsOnboarding: 'DASHBOARD_APPS_ONBOARDING',
    /** Enables the new schedule tab in the dashboard apps project */
    DashboardAppsScheduleTab: 'DASHBOARD_APPS_SCHEDULE_TAB',
    /** Enables the dashboard deliveries tab */
    DeliveriesTab: 'DELIVERIES_TAB',
    /** Enables desk issue reporting */
    DeskIssueReporting: 'DESK_ISSUE_REPORTING',
    /** Document agreements (NDAs, liability waivers, etc.) */
    DocumentAgreements: 'DOCUMENT_AGREEMENTS',
    /** Enables desk reservation edits */
    EditDeskReservations: 'EDIT_DESK_RESERVATIONS',
    /** Enables the employee visits feature set */
    EmployeeVisits: 'EMPLOYEE_VISITS',
    /** Enables the enforcement of workplace service licensing */
    EnforceWorkplaceServiceLicensing: 'ENFORCE_WORKPLACE_SERVICE_LICENSING',
    /** Enables external event sync from OccasionGenius */
    ExternalOccasionGeniusEventSync: 'EXTERNAL_OCCASION_GENIUS_EVENT_SYNC',
    /** Enables Global Hybrid Index page */
    HybridIndex: 'HYBRID_INDEX',
    /** Enables new analytics visualizations */
    InsightsUiRedesign: 'INSIGHTS_UI_REDESIGN',
    /** Enables issue reporting V2 - report issues with spaces */
    IssueReportingV2: 'ISSUE_REPORTING_V2',
    /** Language selection feature flag for project Global */
    LanguageSelectionEnabled: 'LANGUAGE_SELECTION_ENABLED',
    /** Enables the mobile week view home tab */
    MobileHomeTabWeekView: 'MOBILE_HOME_TAB_WEEK_VIEW',
    /** Enables the meetings/space functionality on the Schedule tab in MS Teams */
    MsTeamsSpaceBooking: 'MS_TEAMS_SPACE_BOOKING',
    /** Enables the use of office activities */
    OfficeActivities: 'OFFICE_ACTIVITIES',
    /** Enables the use of office activities for mobile */
    OfficeActivitiesMobile: 'OFFICE_ACTIVITIES_MOBILE',
    /** Enables components intented to improve the office tab performance */
    OfficeTabPerformance: 'OFFICE_TAB_PERFORMANCE',
    /** Enables the onboarding map upload flow */
    OnboardingMapUpload: 'ONBOARDING_MAP_UPLOAD',
    /** Enables passive check in */
    PassiveCheckIn: 'PASSIVE_CHECK_IN',
    /** Enables the new People tab within insights */
    PeopleInsights: 'PEOPLE_INSIGHTS',
    /** Optimizes people search */
    PeopleSearchOptimization: 'PEOPLE_SEARCH_OPTIMIZATION',
    /** Enables people tab in dashboard apps */
    PeopleTabDashboardApps: 'PEOPLE_TAB_DASHBOARD_APPS',
    /** Enables team phoenix to toggle features that are in mid development and still release as needed */
    PhoenixDev: 'PHOENIX_DEV',
    /** Enables Office Utilization insights page */
    RealEstateOptimizationInsights: 'REAL_ESTATE_OPTIMIZATION_INSIGHTS',
    /** Allow user to view the new schedule desk booking flow */
    ScheduleDeskBookingEnabled: 'SCHEDULE_DESK_BOOKING_ENABLED',
    /** Sharptooth team feature flag for development */
    SharptoothDevelopment: 'SHARPTOOTH_DEVELOPMENT',
    /** Deprecate old work place service features across the platform */
    ShowLegacyWorkplaceService: 'SHOW_LEGACY_WORKPLACE_SERVICE',
    /** Enables suggested spaces on mobile */
    SpaceSuggestionsMobile: 'SPACE_SUGGESTIONS_MOBILE',
    /** Enables space recommendations */
    SuggestedSpaces: 'SUGGESTED_SPACES',
    /** Admins can create questions that accept file uploads */
    TicketFileUploads: 'TICKET_FILE_UPLOADS',
    /** Enables the ability to capture images to be used on visitor badges */
    VisitorBadgeImages: 'VISITOR_BADGE_IMAGES',
    /** Enables the ability to add badge printing functionality to arrival displays */
    VisitorBadgePrinting: 'VISITOR_BADGE_PRINTING',
    /** Enables visit list table csv export */
    VisitorCsvExport: 'VISITOR_CSV_EXPORT',
    /** Enables the ability to select a range of dates for a visitor to export */
    VisitorExportDateRange: 'VISITOR_EXPORT_DATE_RANGE',
    /** Visitor managment location enablement */
    VisitorLocationEnablement: 'VISITOR_LOCATION_ENABLEMENT',
    /** Enables permissions checks to gate certain visitor management features */
    VisitorManagementPermissions: 'VISITOR_MANAGEMENT_PERMISSIONS',
    /** Enables who's in sidebar on week view page */
    WeekviewWhosinSidebarEnabled: 'WEEKVIEW_WHOSIN_SIDEBAR_ENABLED',
    /** Enables the ui for workplace services page and request forms to admins and users */
    WorkplaceServices: 'WORKPLACE_SERVICES',
    /** Reveals features for managing work areas */
    WorkAreas: 'WORK_AREAS',
    /** Reveals feature for work areas on mobile */
    WorkAreasMobile: 'WORK_AREAS_MOBILE',
    /** Reveals features for work area insights */
    WorkAreaInsights: 'WORK_AREA_INSIGHTS',
    /** Toggles the updated work week UX/UI */
    WorkWeekImprovementEnabled: 'WORK_WEEK_IMPROVEMENT_ENABLED',
    /** Toggles the updated (V2) work week UX/UI */
    WorkWeekImprovementV2Enabled: 'WORK_WEEK_IMPROVEMENT_V2_ENABLED'
};
export var FeatureType = {
    ActivatedUsers: 'ACTIVATED_USERS',
    ActiveUsers: 'ACTIVE_USERS',
    BookableSeats: 'BOOKABLE_SEATS',
    BookableSpaces: 'BOOKABLE_SPACES',
    ExportableDataDays: 'EXPORTABLE_DATA_DAYS',
    Feature: 'Feature',
    Levels: 'LEVELS',
    Locations: 'LOCATIONS',
    RipplingUsers: 'RIPPLING_USERS',
    Users: 'USERS',
    ViewableDataDays: 'VIEWABLE_DATA_DAYS',
    VisitorEnabledLocations: 'VISITOR_ENABLED_LOCATIONS',
    WorkplaceServicesEnabledLocations: 'WORKPLACE_SERVICES_ENABLED_LOCATIONS'
};
export var FeedbackRating = {
    Negative: 'negative',
    Positive: 'positive'
};
export var GallagherTenancy = {
    Au: 'AU',
    Us: 'US'
};
export var GeneaTenancy = {
    Us: 'US'
};
export var GenericHealthCheckpointEntityType = {
    GuestInvite: 'GUEST_INVITE'
};
export var GenericHealthCheckpointStatus = {
    Complete: 'COMPLETE',
    Failed: 'FAILED',
    Incomplete: 'INCOMPLETE',
    Passed: 'PASSED',
    Unknown: 'UNKNOWN'
};
export var GeoJsonType = {
    Feature: 'Feature'
};
export var GeometryType = {
    Polygon: 'Polygon'
};
export var GetEphemeralDownloadUrlForScannedTicketFileErrorReason = {
    StillScanning: 'STILL_SCANNING',
    UnknownScanError: 'UNKNOWN_SCAN_ERROR',
    VirusDetected: 'VIRUS_DETECTED'
};
export var GetMyWaitlistStatus = {
    /** A waitlist is available and can be opened. */
    Available: 'AVAILABLE',
    /** Waitlist not enabled. */
    NotEnabled: 'NOT_ENABLED',
    /** Currently queued in a waitlist. */
    Scheduled: 'SCHEDULED'
};
export var GetMyWaitlistsStatus = {
    /** A waitlist is available and can be opened. */
    Available: 'AVAILABLE',
    /** Waitlist not enabled. */
    NotEnabled: 'NOT_ENABLED',
    /** Currently queued in a waitlist. */
    Scheduled: 'SCHEDULED'
};
/** How to decide which spaces to suggest - for A/B testing */
export var GetSuggestedSpacesForEventsAlgorithm = {
    FrecencyV1: 'FRECENCY_V1',
    FrecencyV2: 'FRECENCY_V2'
};
/** How to decide which spaces to suggest - for A/B testing */
export var GetSuggestedSpacesForTimeFrameAlgorithm = {
    FrecencyV1: 'FRECENCY_V1',
    FrecencyV2: 'FRECENCY_V2'
};
/** Available fields for ordering onsite entries. */
export var GetWhoIsOnsiteByLocationResponseDayOnsitesOrderField = {
    /** Order by confirmation status Lowest to highest is "SCHEDULED", "REMOTE_CONFIRMATION", "ON_SITE_CONFIRMATION" */
    ConfirmationStatus: 'CONFIRMATION_STATUS',
    /** Order by current user */
    CurrentUser: 'CURRENT_USER',
    /** Order by whether the user is marked as favorite by the current user */
    IsMyFavorite: 'IS_MY_FAVORITE',
    /** Order by user name */
    UserName: 'USER_NAME'
};
export var GoogleWorkingLocationSourceOfTruth = {
    Google: 'GOOGLE',
    Robin: 'ROBIN'
};
export var GuestInviteCanceledReason = {
    CanceledByAdmin: 'CANCELED_BY_ADMIN',
    FailedHealthCheckpoint: 'FAILED_HEALTH_CHECKPOINT'
};
export var GuestInviteStatus = {
    Canceled: 'CANCELED',
    CheckedIn: 'CHECKED_IN',
    CheckedOut: 'CHECKED_OUT',
    CompletedRequirements: 'COMPLETED_REQUIREMENTS',
    Expected: 'EXPECTED',
    Invited: 'INVITED',
    PendingInvite: 'PENDING_INVITE'
};
export var HealthCheckpointStatus = {
    Complete: 'COMPLETE',
    Disabled: 'DISABLED',
    Exempt: 'EXEMPT',
    Failed: 'FAILED',
    Incomplete: 'INCOMPLETE',
    NotAvailable: 'NOT_AVAILABLE',
    Passed: 'PASSED'
};
/** Health status enumeration */
export var HealthStatus = {
    Healthy: 'HEALTHY',
    Unhealthy: 'UNHEALTHY'
};
export var HierarchyPermissionAction = {
    Assignment: 'ASSIGNMENT',
    /** @deprecated Use DELEGATE instead */
    AssignmentDelegate: 'ASSIGNMENT_DELEGATE',
    Book: 'BOOK',
    BypassBookingPolicies: 'BYPASS_BOOKING_POLICIES',
    Delegate: 'DELEGATE',
    ManageOfficeAndMaps: 'MANAGE_OFFICE_AND_MAPS',
    SkipBookingConfirmation: 'SKIP_BOOKING_CONFIRMATION'
};
export var HomepageType = {
    Analytics: 'ANALYTICS',
    Dashboard: 'DASHBOARD',
    Deliveries: 'DELIVERIES',
    MeetingSpaces: 'MEETING_SPACES',
    Office: 'OFFICE',
    People: 'PEOPLE',
    Schedule: 'SCHEDULE',
    Tickets: 'TICKETS',
    Visitors: 'VISITORS'
};
export var IconType = {
    CrcLockers: 'CRC_LOCKERS',
    FaBicycleSolid: 'FA_BICYCLE_SOLID',
    FaCarSolid: 'FA_CAR_SOLID',
    FaChairSolid: 'FA_CHAIR_SOLID',
    FaDumbbellSolid: 'FA_DUMBBELL_SOLID',
    FaFlaskSolid: 'FA_FLASK_SOLID',
    FaHammerBrushSolid: 'FA_HAMMER_BRUSH_SOLID',
    FaHouseBuildingSolid: 'FA_HOUSE_BUILDING_SOLID',
    FaLaptopSolid: 'FA_LAPTOP_SOLID',
    FaMobileScreenButtonSolid: 'FA_MOBILE_SCREEN_BUTTON_SOLID',
    FaPawSolid: 'FA_PAW_SOLID',
    FaPrintSolid: 'FA_PRINT_SOLID',
    FaTabletScreenButtonSolid: 'FA_TABLET_SCREEN_BUTTON_SOLID',
    FaUtensilsSolid: 'FA_UTENSILS_SOLID',
    Hammer_1: 'HAMMER_1',
    Projector_1: 'PROJECTOR_1',
    RoundedSquare_1: 'ROUNDED_SQUARE_1',
    Square_1: 'SQUARE_1',
    Tablet_1: 'TABLET_1',
    Triangle_1: 'TRIANGLE_1'
};
export var LayoutParcelOperation = {
    DeleteResource: 'delete_resource',
    UpsertResource: 'upsert_resource',
    UpsertResourceGroup: 'upsert_resource_group'
};
export var LayoutResourcePolicyDurationType = {
    Days: 'days',
    Hours: 'hours',
    Minutes: 'minutes',
    Months: 'months',
    Weeks: 'weeks',
    Years: 'years'
};
export var LegacyIntegrationResourceType = {
    Calendar: 'CALENDAR',
    Event: 'EVENT',
    Notification: 'NOTIFICATION'
};
export var LegacyIntegrationType = {
    Bluejeans: 'BLUEJEANS',
    BluejeansRelay: 'BLUEJEANS_RELAY',
    Slack: 'SLACK',
    Teams: 'TEAMS',
    Zoom: 'ZOOM'
};
export var LimitStrategy = {
    Adaptive: 'ADAPTIVE',
    Fixed: 'FIXED'
};
export var ListMeetingServiceRequestsSortByCriteria = {
    CreatedAt: 'CREATED_AT',
    EventStartTime: 'EVENT_START_TIME',
    Key: 'KEY',
    ServiceCategoryName: 'SERVICE_CATEGORY_NAME',
    ServiceName: 'SERVICE_NAME',
    Status: 'STATUS',
    UpdatedAt: 'UPDATED_AT'
};
export var ListMeetingServicesCategoriesSortByCriteria = {
    Key: 'KEY',
    Name: 'NAME'
};
export var ListMeetingServicesSortByCriteria = {
    CategoryName: 'CATEGORY_NAME',
    ServiceName: 'SERVICE_NAME',
    UpdatedAt: 'UPDATED_AT'
};
export var MapUploadStatus = {
    AwaitingUpload: 'AWAITING_UPLOAD',
    Unknown: 'UNKNOWN',
    Uploaded: 'UPLOADED'
};
export var MeetingServiceRequestSpaceStatus = {
    /** The space has explicitly accepted the invitation. Some space calendars will never explicitly accept, and merely acquiesce. */
    Accepted: 'ACCEPTED',
    /** The space has not explicitly accepted the invitation, but it also hasn't explicitly declined the invitation, nor are we awaiting any sort of approval. Robin considers this enough for the space to be successfully booked. */
    Acquiesced: 'ACQUIESCED',
    /** The space declined the invitation from the organizer. The most likely reason is that there was a conflict with another event. Can also happen due to disallowed cross-domain invitations or other policy violations. Or, this could be a request-only space and the request was denied by the admin. */
    Declined: 'DECLINED',
    /** We have seen the event (e.g. through other space calendars), but the space that this service request was intended for is missing. The service request may have been created for an event that was not saved yet, and the creator removed the space before saving the event. Could also happen if someone was editing an event, added a space, moved a service request to that space, but then removed (or failed to add) the space. */
    Missing: 'MISSING',
    /** We have not seen anything related to this event. The service request may have been created for an event that was not saved yet, and the creator either never saved the event or removed all spaces before saving. */
    NotSynced: 'NOT_SYNCED',
    /** Either the event was cancelled by the organizer, or the space was disinvited from the event. It is difficult to tell the difference between the two situations. */
    RemovedOrEventCancelled: 'REMOVED_OR_EVENT_CANCELLED',
    /** The space has tentatively accepted the invitation, but we're still waiting for an admin to approve the request. */
    Requested: 'REQUESTED'
};
export var MeetingServiceRequestStatus = {
    Blocked: 'BLOCKED',
    Cancelled: 'CANCELLED',
    Done: 'DONE',
    InProgress: 'IN_PROGRESS',
    NeedsApproval: 'NEEDS_APPROVAL',
    Rejected: 'REJECTED',
    Todo: 'TODO'
};
export var MobileActivityType = {
    InVehicle: 'in_vehicle',
    OnBicycle: 'on_bicycle',
    OnFoot: 'on_foot',
    Running: 'running',
    Still: 'still',
    Unknown: 'unknown',
    Walking: 'walking'
};
export var MobileGeofenceAction = {
    Dwell: 'DWELL',
    Enter: 'ENTER',
    Exit: 'EXIT'
};
export var MobileLocationEvent = {
    Geofence: 'geofence',
    Heartbeat: 'heartbeat',
    Motionchange: 'motionchange',
    Providerchange: 'providerchange'
};
export var NeighborhoodColorType = {
    NhA: 'NH_A',
    NhB: 'NH_B',
    NhC: 'NH_C',
    NhD: 'NH_D',
    NhE: 'NH_E',
    NhF: 'NH_F',
    NhG: 'NH_G',
    NhH: 'NH_H',
    NhI: 'NH_I',
    NhJ: 'NH_J',
    NhK: 'NH_K',
    NhL: 'NH_L',
    NhM: 'NH_M',
    NhN: 'NH_N'
};
export var NeighborhoodResourceType = {
    Desk: 'DESK'
};
export var NotificationPreferenceKey = {
    WhosInDigestEmail: 'WHOS_IN_DIGEST_EMAIL'
};
export var NotificationSettingType = {
    Email: 'EMAIL',
    Push: 'PUSH',
    Slack: 'SLACK',
    Teams: 'TEAMS'
};
export var OffsetStrategy = {
    Fixed: 'FIXED'
};
export var OnsiteConfirmationMethod = {
    /** Badge Reader */
    BadgeReader: 'BADGE_READER',
    /** Geofence */
    Geofence: 'GEOFENCE',
    /** IP Address */
    IpAddress: 'IP_ADDRESS',
    /** Other */
    Other: 'OTHER',
    /** QR Code */
    QrCode: 'QR_CODE',
    /** Seat Confirmation */
    SeatConfirmation: 'SEAT_CONFIRMATION'
};
export var OnsiteType = {
    OnSiteConfirmation: 'ON_SITE_CONFIRMATION',
    RemoteConfirmation: 'REMOTE_CONFIRMATION',
    Scheduled: 'SCHEDULED'
};
export var OperatingSystem = {
    Android: 'ANDROID',
    Ios: 'IOS'
};
/** Specifies the direction of ordering for query results. */
export var OrderDirection = {
    /** Ascending order (A-Z, 0-9, false-true) */
    Asc: 'ASC',
    /** Descending order (Z-A, 9-0, true-false) */
    Desc: 'DESC'
};
export var Ordinality = {
    Asc: 'ASC',
    Desc: 'DESC'
};
export var OwnerType = {
    Seat: 'SEAT',
    Space: 'SPACE',
    Unassigned: 'UNASSIGNED'
};
export var ParticipationStatus = {
    Accepted: 'ACCEPTED',
    Declined: 'DECLINED',
    NotResponded: 'NOT_RESPONDED',
    Tentative: 'TENTATIVE',
    Unknown: 'UNKNOWN'
};
export var PermissionHierarchyTarget = {
    Campus: 'CAMPUS',
    Level: 'LEVEL',
    Location: 'LOCATION',
    Organization: 'ORGANIZATION',
    ResourceGroup: 'RESOURCE_GROUP',
    ResourceInstance: 'RESOURCE_INSTANCE'
};
export var PlaceAvailabilityType = {
    Available: 'AVAILABLE',
    Unavailable: 'UNAVAILABLE'
};
export var PlaceType = {
    Location: 'location'
};
export var PlaceUnavailableReason = {
    /** The location is closed according to its working hours */
    BuildingClosed: 'BUILDING_CLOSED',
    /** The maxiumum number of flexible desks have been booked in this location */
    MaxCapacityReached: 'MAX_CAPACITY_REACHED',
    /** The user doesn't have a pass */
    NoAccess: 'NO_ACCESS',
    /** The user has a pass but it doesn't grant access to the location */
    NoLocationAccess: 'NO_LOCATION_ACCESS',
    /** The user has a pass to the location, but it's not valid during the specified start and end times */
    ScheduleViolation: 'SCHEDULE_VIOLATION'
};
export var PolicyType = {
    AbandonedResourceProtection: 'ABANDONED_RESOURCE_PROTECTION',
    AdvancedBookingThreshold: 'ADVANCED_BOOKING_THRESHOLD',
    AdvanceCheckInWindow: 'ADVANCE_CHECK_IN_WINDOW',
    AllowOverlappingBookings: 'ALLOW_OVERLAPPING_BOOKINGS',
    BookingPrivacy: 'BOOKING_PRIVACY',
    LocalCheckInOnly: 'LOCAL_CHECK_IN_ONLY',
    MaxBookingLength: 'MAX_BOOKING_LENGTH',
    PreventBookingFromKiosk: 'PREVENT_BOOKING_FROM_KIOSK',
    Recurrence: 'RECURRENCE',
    RequireCheckIn: 'REQUIRE_CHECK_IN',
    ReservationType: 'RESERVATION_TYPE',
    ResourceBusy: 'RESOURCE_BUSY',
    ResourceSharing: 'RESOURCE_SHARING',
    RestrictBookingToWorkingHours: 'RESTRICT_BOOKING_TO_WORKING_HOURS'
};
export var ProxiedEventResponseStatus = {
    Cancelled: 'CANCELLED',
    Confirmed: 'CONFIRMED',
    Tentative: 'TENTATIVE',
    Unknown: 'UNKNOWN'
};
export var Query_Visit_Document_Sort_By = {
    AddedOn: 'ADDED_ON',
    Name: 'NAME',
    Status: 'STATUS'
};
export var Query_Workflow_Sort_Order = {
    Ascending: 'ASCENDING',
    Descending: 'DESCENDING'
};
export var QueryablePermissionAction = {
    Assignment: 'ASSIGNMENT',
    /** @deprecated Use DELEGATE instead */
    AssignmentDelegate: 'ASSIGNMENT_DELEGATE',
    Book: 'BOOK',
    BypassBookingPolicies: 'BYPASS_BOOKING_POLICIES',
    CustomResourceCreate: 'CUSTOM_RESOURCE_CREATE',
    Delegate: 'DELEGATE',
    ManageOfficeAndMaps: 'MANAGE_OFFICE_AND_MAPS',
    SkipBookingConfirmation: 'SKIP_BOOKING_CONFIRMATION'
};
export var RecurringReservationDayOfWeek = {
    Friday: 'FRIDAY',
    Monday: 'MONDAY',
    Saturday: 'SATURDAY',
    Sunday: 'SUNDAY',
    Thursday: 'THURSDAY',
    Tuesday: 'TUESDAY',
    Wednesday: 'WEDNESDAY'
};
export var RecurringReservationFrequency = {
    Daily: 'DAILY',
    Hourly: 'HOURLY',
    Minutely: 'MINUTELY',
    Monthly: 'MONTHLY',
    Secondly: 'SECONDLY',
    Weekly: 'WEEKLY',
    Yearly: 'YEARLY'
};
export var RecurringReservationMonth = {
    April: 'APRIL',
    August: 'AUGUST',
    December: 'DECEMBER',
    February: 'FEBRUARY',
    January: 'JANUARY',
    July: 'JULY',
    June: 'JUNE',
    March: 'MARCH',
    May: 'MAY',
    November: 'NOVEMBER',
    October: 'OCTOBER',
    September: 'SEPTEMBER'
};
export var RejectMeetingServiceRequestErrorReason = {
    Conflict: 'CONFLICT'
};
export var RemoteTypeEnum = {
    /** Microsoft Exchange Calendar integration */
    Exchange: 'EXCHANGE',
    /** Google Calendar integration */
    Google: 'GOOGLE',
    /** Microsoft Office 365 Calendar integration */
    Office_365: 'OFFICE_365'
};
export var RemoveSpaceFromEventErrorReasons = {
    LackingEventUpdatePermissions: 'LACKING_EVENT_UPDATE_PERMISSIONS',
    Unknown: 'UNKNOWN'
};
export var RequestMeetingServiceForDraftEventAtSpaceErrorReason = {
    /** Admin could archive the service while requester is filling out form */
    MeetingServiceIsArchived: 'MEETING_SERVICE_IS_ARCHIVED',
    /** Admin could change availability while requester is filling out form */
    MeetingServiceNotAvailable: 'MEETING_SERVICE_NOT_AVAILABLE',
    /** Admin published a new version while requester is filling out form. Old versions are allowed to be created for a short period of time, but that time has passed. */
    MeetingServiceVersionOutdated: 'MEETING_SERVICE_VERSION_OUTDATED'
};
export var RequestMeetingServiceForExistingEventAtSpaceErrorReason = {
    /** Not fixable, must start over and create a new event. Ideally, client would prevent getting this far in the first place. */
    EventHasNoUid: 'EVENT_HAS_NO_UID',
    /** Admin could archive the service while requester is filling out form */
    MeetingServiceIsArchived: 'MEETING_SERVICE_IS_ARCHIVED',
    /** Admin could change availability while requester is filling out form */
    MeetingServiceNotAvailable: 'MEETING_SERVICE_NOT_AVAILABLE',
    /** Admin published a new version while requester is filling out form. Old versions are allowed to be created for a short period of time, but that time has passed. */
    MeetingServiceVersionOutdated: 'MEETING_SERVICE_VERSION_OUTDATED'
};
/** Visibility of reservation */
export var ReservationVisibility = {
    Confidential: 'CONFIDENTIAL',
    Default: 'DEFAULT',
    Personal: 'PERSONAL',
    Private: 'PRIVATE',
    Public: 'PUBLIC'
};
export var ResourcePermissionAction = {
    Assign: 'ASSIGN',
    Book: 'BOOK',
    Delegate: 'DELEGATE',
    SkipBookingConfirmation: 'SKIP_BOOKING_CONFIRMATION'
};
export var ResourceReservationConfirmationErrorCode = {
    AdvancedConfirmationWindowTooEarly: 'ADVANCED_CONFIRMATION_WINDOW_TOO_EARLY',
    LocalConfirmationRequired: 'LOCAL_CONFIRMATION_REQUIRED',
    ReservationAlreadyConfirmed: 'RESERVATION_ALREADY_CONFIRMED',
    ReservationConfirmationWindowExpired: 'RESERVATION_CONFIRMATION_WINDOW_EXPIRED',
    ReservationDoesNotExist: 'RESERVATION_DOES_NOT_EXIST',
    ReservationPreviouslyCanceled: 'RESERVATION_PREVIOUSLY_CANCELED',
    TimezoneConversionFailed: 'TIMEZONE_CONVERSION_FAILED'
};
export var ResourceReservationValidationFailureType = {
    BookingOverlaps: 'BOOKING_OVERLAPS',
    CantBookFromKiosk: 'CANT_BOOK_FROM_KIOSK',
    ExceedsAdvancedBookingThreshold: 'EXCEEDS_ADVANCED_BOOKING_THRESHOLD',
    ExceedsMaximumBookingLength: 'EXCEEDS_MAXIMUM_BOOKING_LENGTH',
    IncoherentRequestToEditReservationSeries: 'INCOHERENT_REQUEST_TO_EDIT_RESERVATION_SERIES',
    InvalidRequestToEditPastRecurringReservationInstance: 'INVALID_REQUEST_TO_EDIT_PAST_RECURRING_RESERVATION_INSTANCE',
    InvalidRequestToRescheduleRecurringReservation: 'INVALID_REQUEST_TO_RESCHEDULE_RECURRING_RESERVATION',
    InvalidRequestToRescheduleSingleDayReservation: 'INVALID_REQUEST_TO_RESCHEDULE_SINGLE_DAY_RESERVATION',
    MissingBookingPermission: 'MISSING_BOOKING_PERMISSION',
    OutsideOfWorkingHours: 'OUTSIDE_OF_WORKING_HOURS',
    RecurrenceNotAllowed: 'RECURRENCE_NOT_ALLOWED',
    ReservationDoesNotExist: 'RESERVATION_DOES_NOT_EXIST',
    ReservationHasEnded: 'RESERVATION_HAS_ENDED',
    ReservationTypeNotAllowed: 'RESERVATION_TYPE_NOT_ALLOWED',
    ResourceBusy: 'RESOURCE_BUSY',
    ResourceDoesNotExist: 'RESOURCE_DOES_NOT_EXIST',
    ScheduleDoesNotExist: 'SCHEDULE_DOES_NOT_EXIST',
    ViolatesMaximumBookingThreshold: 'VIOLATES_MAXIMUM_BOOKING_THRESHOLD'
};
export var RolePermissionAction = {
    CustomResourceCreate: 'CUSTOM_RESOURCE_CREATE'
};
export var RollbackStatus = {
    Failed: 'FAILED',
    RolledBack: 'ROLLED_BACK'
};
export var RolloutStatus = {
    Failed: 'FAILED',
    Migrated: 'MIGRATED',
    Skipped: 'SKIPPED'
};
export var ScheduleSourceType = {
    Google: 'google',
    User: 'user'
};
export var SettingDataType = {
    Boolean: 'BOOLEAN',
    Integer: 'INTEGER',
    Json: 'JSON',
    String: 'STRING'
};
export var SettingOwnerType = {
    User: 'USER'
};
export var SettingValueType = {
    Boolean: 'boolean',
    Number: 'number',
    String: 'string'
};
export var SigmaEmbedType = {
    Creator: 'CREATOR',
    Viewer: 'VIEWER'
};
export var SigmaLocationType = {
    Personal: 'PERSONAL',
    Shared: 'SHARED'
};
export var SnapTo = {
    Fifteen: 'FIFTEEN',
    Sixty: 'SIXTY',
    Thirty: 'THIRTY',
    Zero: 'ZERO'
};
export var SortDirection = {
    Asc: 'ASC',
    Desc: 'DESC'
};
/** The order with which to sort */
export var SortOrder = {
    Ascending: 'ASCENDING',
    Descending: 'DESCENDING'
};
export var SpaceAvailability = {
    /** Currently available */
    Available: 'AVAILABLE',
    /** Resource has been booked and confirmed */
    BookedConfirmed: 'BOOKED_CONFIRMED',
    /** Resource has been booked and not confirmed */
    BookedUnconfirmed: 'BOOKED_UNCONFIRMED',
    /** Resource marked as unavailable for booking */
    Unavailable: 'UNAVAILABLE',
    /** Resource schedule not found */
    Unknown: 'UNKNOWN'
};
export var SpaceFilters = {
    Disabled: 'DISABLED',
    Enabled: 'ENABLED',
    Scheduling: 'SCHEDULING'
};
export var SpaceScheduleConfiguration = {
    OnDemand: 'ON_DEMAND',
    RequestOnly: 'REQUEST_ONLY',
    Scheduled: 'SCHEDULED'
};
export var SpaceType = {
    Breakout: 'BREAKOUT',
    BreakRoom: 'BREAK_ROOM',
    Cafe: 'CAFE',
    Cafeteria: 'CAFETERIA',
    Call: 'CALL',
    Classroom: 'CLASSROOM',
    Conference: 'CONFERENCE',
    Event: 'EVENT',
    Fitness: 'FITNESS',
    Huddle: 'HUDDLE',
    Interview: 'INTERVIEW',
    Kitchen: 'KITCHEN',
    Lab: 'LAB',
    Lactation: 'LACTATION',
    Listening: 'LISTENING',
    Lobby: 'LOBBY',
    Lounge: 'LOUNGE',
    Meeting: 'MEETING',
    Office: 'OFFICE',
    Other: 'OTHER',
    Parking: 'PARKING',
    Project: 'PROJECT',
    Restroom: 'RESTROOM',
    RestroomFemale: 'RESTROOM_FEMALE',
    RestroomMale: 'RESTROOM_MALE',
    Studio: 'STUDIO',
    StudyRoom: 'STUDY_ROOM',
    Theater: 'THEATER',
    Utility: 'UTILITY',
    Work: 'WORK'
};
/** The key to sort survey responses by */
export var SurveyResponseSortKey = {
    InOfficeAt: 'IN_OFFICE_AT',
    Rating: 'RATING'
};
/** Status of the survey response */
export var SurveyResponseStatus = {
    Completed: 'COMPLETED',
    Dismissed: 'DISMISSED',
    Expired: 'EXPIRED',
    Pending: 'PENDING'
};
export var SyncState = {
    Done: 'DONE',
    InProgress: 'IN_PROGRESS',
    NeverHappened: 'NEVER_HAPPENED'
};
export var TicketWorkflowKind = {
    MeetingService: 'MEETING_SERVICE',
    /** This workflow describes a form that must be completed in order to request a request-only space. */
    SpaceRequestForm: 'SPACE_REQUEST_FORM'
};
export var TimeInclusivityType = {
    Exclusive: 'EXCLUSIVE',
    Inclusive: 'INCLUSIVE'
};
export var UnbookableReasonType = {
    AdminOnlyBooking: 'ADMIN_ONLY_BOOKING',
    ConflictWithAnotherMeeting: 'CONFLICT_WITH_ANOTHER_MEETING',
    LackingSpaceBookingPermissions: 'LACKING_SPACE_BOOKING_PERMISSIONS',
    OutsideWorkingHours: 'OUTSIDE_WORKING_HOURS',
    OverMaxLength: 'OVER_MAX_LENGTH',
    RecurrenceNotAllowed: 'RECURRENCE_NOT_ALLOWED',
    TooFarInFuture: 'TOO_FAR_IN_FUTURE'
};
export var UnconfirmableReasonType = {
    CannotConfirmSeriesMaster: 'CANNOT_CONFIRM_SERIES_MASTER',
    CannotConfirmSharedDesk: 'CANNOT_CONFIRM_SHARED_DESK',
    CheckinDisabled: 'CHECKIN_DISABLED',
    MissingReservationEndTime: 'MISSING_RESERVATION_END_TIME',
    OutsideOfCheckInWindow: 'OUTSIDE_OF_CHECK_IN_WINDOW'
};
export var UpdatableMeetingServiceRequestStatus = {
    Blocked: 'BLOCKED',
    Cancelled: 'CANCELLED',
    Done: 'DONE',
    InProgress: 'IN_PROGRESS',
    Todo: 'TODO'
};
export var UpdateMeetingServiceErrorResponseReason = {
    CategoryMissing: 'CATEGORY_MISSING',
    /** meeting service version ID is not the latest version for the meeting service */
    Conflict: 'CONFLICT',
    /** This meeting service has kind=SPACE_REQUEST_FORM, and one of its spaces already has a request form */
    SpaceAlreadyHasRequestForm: 'SPACE_ALREADY_HAS_REQUEST_FORM'
};
export var UpdateMeetingServiceRequestStatusErrorReason = {
    /** Events that have ended can only change to Canceled/Done */
    EventAlreadyEnded: 'EVENT_ALREADY_ENDED',
    /** Cannot un-cancel status because event or space no longer exists */
    EventOrSpaceNoLongerExists: 'EVENT_OR_SPACE_NO_LONGER_EXISTS',
    /** Another user already changed the status */
    StatusAlreadyChanged: 'STATUS_ALREADY_CHANGED',
    /** The user is not assigned to the ticket */
    UserNotAssignee: 'USER_NOT_ASSIGNEE'
};
export var UserDefaultRoleSlug = {
    Admin: 'ADMIN',
    Member: 'MEMBER',
    Owner: 'OWNER'
};
export var UserSortBy = {
    Favorite: 'FAVORITE',
    Name: 'NAME'
};
export var UserSortOrder = {
    Ascending: 'ASCENDING',
    Descending: 'DESCENDING'
};
export var Visit_Document_Status = {
    Archived: 'ARCHIVED',
    Inactive: 'INACTIVE',
    Live: 'LIVE'
};
export var VerkadaTenancy = {
    Au: 'AU',
    Eu: 'EU',
    Gov: 'GOV',
    Us: 'US'
};
export var VisitAsyncRequestReport = {
    Done: 'DONE',
    Error: 'ERROR',
    HcpCreated: 'HCP_CREATED',
    VisitCreated: 'VISIT_CREATED'
};
export var VisitAsyncRequestStatus = {
    Complete: 'COMPLETE',
    Error: 'ERROR',
    InProgress: 'IN_PROGRESS',
    RequestReceived: 'REQUEST_RECEIVED'
};
export var VisitDocumentAgreementStatus = {
    Accept: 'ACCEPT'
};
export var VisitDocumentCompletionStatus = {
    Complete: 'COMPLETE',
    Incomplete: 'INCOMPLETE'
};
export var VisitDocumentNameStatusAndTypesField = {
    LocationId: 'LOCATION_ID',
    Status: 'STATUS',
    VisitType: 'VISIT_TYPE'
};
export var VisitEventAcknowledgement = {
    VisitStartingSoon: 'VISIT_STARTING_SOON'
};
export var VisitOrganizerType = {
    ArrivalDisplay: 'ARRIVAL_DISPLAY',
    User: 'USER'
};
export var VisitType = {
    CustomerVisit: 'CUSTOMER_VISIT',
    Event: 'EVENT',
    JobInterview: 'JOB_INTERVIEW',
    Maintenance: 'MAINTENANCE',
    Other: 'OTHER',
    VipVisit: 'VIP_VISIT'
};
export var VisitTypeSource = {
    Default: 'DEFAULT',
    Location: 'LOCATION',
    Organization: 'ORGANIZATION'
};
export var WorkPolicyIntervalType = {
    Monthly: 'MONTHLY',
    SpecificDays: 'SPECIFIC_DAYS',
    Weekly: 'WEEKLY'
};
export var WorkPolicyStatus = {
    Active: 'ACTIVE',
    Inactive: 'INACTIVE',
    Scheduled: 'SCHEDULED'
};
/** Describes the type of zone */
export var ZoneType = {
    /** A pod is a collection of desks */
    Pod: 'POD',
    /** A zone with the table type is typically a large table with many seats */
    Table: 'TABLE'
};
export var MapSpaceStateForLevelDocument = gql(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    query MapSpaceStateForLevel($levelId: ID!, $intervalInMinutes: Int, $startTime: Date, $meetingDurationInMinutes: Int) {\n  getLevelById(id: $levelId) {\n    id\n    name\n    levelLocation {\n      id\n      name\n    }\n    spaces {\n      id\n      name\n      type\n      capacity\n      image\n      isDisabled\n      isAccessible\n      isManaged\n      locationId\n      amenities {\n        id\n        name\n        amenityId\n        quantity\n      }\n      calendar {\n        calendarId\n      }\n      scheduleConfiguration\n      windowedAvailability(\n        numberOfWindows: 1\n        intervalInMinutes: $intervalInMinutes\n        startTime: $startTime\n        meetingDurationInMinutes: $meetingDurationInMinutes\n      ) {\n        status\n        unbookableReasons\n        isConfirmed\n        start\n        end\n      }\n    }\n  }\n}\n    "], ["\n    query MapSpaceStateForLevel($levelId: ID!, $intervalInMinutes: Int, $startTime: Date, $meetingDurationInMinutes: Int) {\n  getLevelById(id: $levelId) {\n    id\n    name\n    levelLocation {\n      id\n      name\n    }\n    spaces {\n      id\n      name\n      type\n      capacity\n      image\n      isDisabled\n      isAccessible\n      isManaged\n      locationId\n      amenities {\n        id\n        name\n        amenityId\n        quantity\n      }\n      calendar {\n        calendarId\n      }\n      scheduleConfiguration\n      windowedAvailability(\n        numberOfWindows: 1\n        intervalInMinutes: $intervalInMinutes\n        startTime: $startTime\n        meetingDurationInMinutes: $meetingDurationInMinutes\n      ) {\n        status\n        unbookableReasons\n        isConfirmed\n        start\n        end\n      }\n    }\n  }\n}\n    "])));
/**
 * __useMapSpaceStateForLevelQuery__
 *
 * To run a query within a React component, call `useMapSpaceStateForLevelQuery` and pass it any options that fit your needs.
 * When your component renders, `useMapSpaceStateForLevelQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMapSpaceStateForLevelQuery({
 *   variables: {
 *      levelId: // value for 'levelId'
 *      intervalInMinutes: // value for 'intervalInMinutes'
 *      startTime: // value for 'startTime'
 *      meetingDurationInMinutes: // value for 'meetingDurationInMinutes'
 *   },
 * });
 */
export function useMapSpaceStateForLevelQuery(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useQuery(MapSpaceStateForLevelDocument, options);
}
export function useMapSpaceStateForLevelLazyQuery(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useLazyQuery(MapSpaceStateForLevelDocument, options);
}
export var EventComposerGetSuggestedSpacesForTimeFrameDocument = gql(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    query EventComposerGetSuggestedSpacesForTimeFrame($input: GetSuggestedSpacesForTimeFrameInput!) {\n  getSuggestedSpacesForTimeFrame(input: $input) {\n    suggestedSpaces {\n      id\n      name\n    }\n  }\n}\n    "], ["\n    query EventComposerGetSuggestedSpacesForTimeFrame($input: GetSuggestedSpacesForTimeFrameInput!) {\n  getSuggestedSpacesForTimeFrame(input: $input) {\n    suggestedSpaces {\n      id\n      name\n    }\n  }\n}\n    "])));
/**
 * __useEventComposerGetSuggestedSpacesForTimeFrameQuery__
 *
 * To run a query within a React component, call `useEventComposerGetSuggestedSpacesForTimeFrameQuery` and pass it any options that fit your needs.
 * When your component renders, `useEventComposerGetSuggestedSpacesForTimeFrameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEventComposerGetSuggestedSpacesForTimeFrameQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEventComposerGetSuggestedSpacesForTimeFrameQuery(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useQuery(EventComposerGetSuggestedSpacesForTimeFrameDocument, options);
}
export function useEventComposerGetSuggestedSpacesForTimeFrameLazyQuery(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useLazyQuery(EventComposerGetSuggestedSpacesForTimeFrameDocument, options);
}
export var EventComposerGetSuggestedSpacesForEventsDocument = gql(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    query EventComposerGetSuggestedSpacesForEvents($input: GetSuggestedSpacesForEventsInput!) {\n  getSuggestedSpacesForEvents(input: $input) {\n    suggestedSpaces {\n      eventId\n      space {\n        id\n        name\n      }\n    }\n  }\n}\n    "], ["\n    query EventComposerGetSuggestedSpacesForEvents($input: GetSuggestedSpacesForEventsInput!) {\n  getSuggestedSpacesForEvents(input: $input) {\n    suggestedSpaces {\n      eventId\n      space {\n        id\n        name\n      }\n    }\n  }\n}\n    "])));
/**
 * __useEventComposerGetSuggestedSpacesForEventsQuery__
 *
 * To run a query within a React component, call `useEventComposerGetSuggestedSpacesForEventsQuery` and pass it any options that fit your needs.
 * When your component renders, `useEventComposerGetSuggestedSpacesForEventsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEventComposerGetSuggestedSpacesForEventsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEventComposerGetSuggestedSpacesForEventsQuery(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useQuery(EventComposerGetSuggestedSpacesForEventsDocument, options);
}
export function useEventComposerGetSuggestedSpacesForEventsLazyQuery(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useLazyQuery(EventComposerGetSuggestedSpacesForEventsDocument, options);
}
export var EventComposerGetSuggestedSpacesFeatureFlagDocument = gql(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    query EventComposerGetSuggestedSpacesFeatureFlag {\n  suggestedSpacesFeatureFlagEnabled: isFeatureFlagEnabledForOrgOrMe(\n    flagType: SUGGESTED_SPACES\n  )\n}\n    "], ["\n    query EventComposerGetSuggestedSpacesFeatureFlag {\n  suggestedSpacesFeatureFlagEnabled: isFeatureFlagEnabledForOrgOrMe(\n    flagType: SUGGESTED_SPACES\n  )\n}\n    "])));
/**
 * __useEventComposerGetSuggestedSpacesFeatureFlagQuery__
 *
 * To run a query within a React component, call `useEventComposerGetSuggestedSpacesFeatureFlagQuery` and pass it any options that fit your needs.
 * When your component renders, `useEventComposerGetSuggestedSpacesFeatureFlagQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEventComposerGetSuggestedSpacesFeatureFlagQuery({
 *   variables: {
 *   },
 * });
 */
export function useEventComposerGetSuggestedSpacesFeatureFlagQuery(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useQuery(EventComposerGetSuggestedSpacesFeatureFlagDocument, options);
}
export function useEventComposerGetSuggestedSpacesFeatureFlagLazyQuery(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useLazyQuery(EventComposerGetSuggestedSpacesFeatureFlagDocument, options);
}
export var EventComposerGetSuggestedSpacesEnabledForOrgDocument = gql(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n    query EventComposerGetSuggestedSpacesEnabledForOrg {\n  suggestedSpacesEnabled: getSuggestedSpacesEnabledForOrg\n}\n    "], ["\n    query EventComposerGetSuggestedSpacesEnabledForOrg {\n  suggestedSpacesEnabled: getSuggestedSpacesEnabledForOrg\n}\n    "])));
/**
 * __useEventComposerGetSuggestedSpacesEnabledForOrgQuery__
 *
 * To run a query within a React component, call `useEventComposerGetSuggestedSpacesEnabledForOrgQuery` and pass it any options that fit your needs.
 * When your component renders, `useEventComposerGetSuggestedSpacesEnabledForOrgQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEventComposerGetSuggestedSpacesEnabledForOrgQuery({
 *   variables: {
 *   },
 * });
 */
export function useEventComposerGetSuggestedSpacesEnabledForOrgQuery(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useQuery(EventComposerGetSuggestedSpacesEnabledForOrgDocument, options);
}
export function useEventComposerGetSuggestedSpacesEnabledForOrgLazyQuery(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useLazyQuery(EventComposerGetSuggestedSpacesEnabledForOrgDocument, options);
}
export var DashboardAppsHeaderUserPermissionsDocument = gql(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n    query DashboardAppsHeaderUserPermissions {\n  getCurrentUserAndOrgs {\n    userId\n    hasOfficeAccessManagePermissionForCurrentTenant\n    hasWorkweekViewForCurrentTenant\n    hasSpacesReservePublicPermissionForCurrentTenant\n    hasSeatsReservePublicPermissionForCurrentTenant\n    hasListUserPermissionForCurrentTenant\n  }\n}\n    "], ["\n    query DashboardAppsHeaderUserPermissions {\n  getCurrentUserAndOrgs {\n    userId\n    hasOfficeAccessManagePermissionForCurrentTenant\n    hasWorkweekViewForCurrentTenant\n    hasSpacesReservePublicPermissionForCurrentTenant\n    hasSeatsReservePublicPermissionForCurrentTenant\n    hasListUserPermissionForCurrentTenant\n  }\n}\n    "])));
/**
 * __useDashboardAppsHeaderUserPermissionsQuery__
 *
 * To run a query within a React component, call `useDashboardAppsHeaderUserPermissionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useDashboardAppsHeaderUserPermissionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDashboardAppsHeaderUserPermissionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useDashboardAppsHeaderUserPermissionsQuery(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useQuery(DashboardAppsHeaderUserPermissionsDocument, options);
}
export function useDashboardAppsHeaderUserPermissionsLazyQuery(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useLazyQuery(DashboardAppsHeaderUserPermissionsDocument, options);
}
export var GetUsersByKeywordDocument = gql(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n    query getUsersByKeyword($organizationId: ID!, $keyword: String!) {\n  getUsersByKeyword(organizationId: $organizationId, keyword: $keyword) {\n    id\n    name\n    avatar\n    primaryEmail {\n      email\n    }\n  }\n}\n    "], ["\n    query getUsersByKeyword($organizationId: ID!, $keyword: String!) {\n  getUsersByKeyword(organizationId: $organizationId, keyword: $keyword) {\n    id\n    name\n    avatar\n    primaryEmail {\n      email\n    }\n  }\n}\n    "])));
/**
 * __useGetUsersByKeywordQuery__
 *
 * To run a query within a React component, call `useGetUsersByKeywordQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUsersByKeywordQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUsersByKeywordQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      keyword: // value for 'keyword'
 *   },
 * });
 */
export function useGetUsersByKeywordQuery(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useQuery(GetUsersByKeywordDocument, options);
}
export function useGetUsersByKeywordLazyQuery(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useLazyQuery(GetUsersByKeywordDocument, options);
}
export var GetLocationsByOrgIdDocument = gql(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n    query getLocationsByOrgId($id: ID!) {\n  getOrganizationById(id: $id) {\n    id\n    locations {\n      id\n      name\n      totalSpaces\n      levels {\n        id\n        name\n      }\n    }\n  }\n}\n    "], ["\n    query getLocationsByOrgId($id: ID!) {\n  getOrganizationById(id: $id) {\n    id\n    locations {\n      id\n      name\n      totalSpaces\n      levels {\n        id\n        name\n      }\n    }\n  }\n}\n    "])));
/**
 * __useGetLocationsByOrgIdQuery__
 *
 * To run a query within a React component, call `useGetLocationsByOrgIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLocationsByOrgIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLocationsByOrgIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetLocationsByOrgIdQuery(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useQuery(GetLocationsByOrgIdDocument, options);
}
export function useGetLocationsByOrgIdLazyQuery(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useLazyQuery(GetLocationsByOrgIdDocument, options);
}
export var GetMeetingServiceRequestsForEventBySpaceIdDocument = gql(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n    query GetMeetingServiceRequestsForEventBySpaceId($spaceId: [ID!]!, $eventInstance: EventInstanceReference!) {\n  getSpacesByIds(ids: $spaceId) {\n    id\n    totalPriceOfMeetingServiceRequests(eventInstance: $eventInstance) {\n      amountMajor\n      currencyCode\n    }\n    hasAnyAvailableMeetingServices\n    currentUserCanRequestMeetingServicesForEvent(eventInstance: $eventInstance)\n    meetingServiceRequests(eventInstance: $eventInstance) {\n      id\n      key\n      meetingServiceRequestStatus\n      permissions {\n        canChangeAnswers\n        canDeleteOrCancel\n      }\n      totalPrice {\n        amountMajor\n        currencyCode\n      }\n      meetingService {\n        id\n        name\n        category {\n          id\n          name\n        }\n      }\n      completedForm {\n        id\n        questions {\n          ... on AnsweredTicketQuestionExpectingText {\n            answer\n          }\n          ... on AnsweredTicketQuestionExpectingChoices {\n            choices {\n              id\n              name\n            }\n          }\n          ... on AnsweredTicketQuestionExpectingMenuChoices {\n            choices {\n              quantity\n              option {\n                id\n                name\n              }\n              subtotalPrice {\n                amountMajor\n                currencyCode\n              }\n            }\n          }\n          ... on AnsweredTicketQuestionExpectingFiles {\n            files {\n              id\n              name\n            }\n          }\n        }\n      }\n    }\n  }\n}\n    "], ["\n    query GetMeetingServiceRequestsForEventBySpaceId($spaceId: [ID!]!, $eventInstance: EventInstanceReference!) {\n  getSpacesByIds(ids: $spaceId) {\n    id\n    totalPriceOfMeetingServiceRequests(eventInstance: $eventInstance) {\n      amountMajor\n      currencyCode\n    }\n    hasAnyAvailableMeetingServices\n    currentUserCanRequestMeetingServicesForEvent(eventInstance: $eventInstance)\n    meetingServiceRequests(eventInstance: $eventInstance) {\n      id\n      key\n      meetingServiceRequestStatus\n      permissions {\n        canChangeAnswers\n        canDeleteOrCancel\n      }\n      totalPrice {\n        amountMajor\n        currencyCode\n      }\n      meetingService {\n        id\n        name\n        category {\n          id\n          name\n        }\n      }\n      completedForm {\n        id\n        questions {\n          ... on AnsweredTicketQuestionExpectingText {\n            answer\n          }\n          ... on AnsweredTicketQuestionExpectingChoices {\n            choices {\n              id\n              name\n            }\n          }\n          ... on AnsweredTicketQuestionExpectingMenuChoices {\n            choices {\n              quantity\n              option {\n                id\n                name\n              }\n              subtotalPrice {\n                amountMajor\n                currencyCode\n              }\n            }\n          }\n          ... on AnsweredTicketQuestionExpectingFiles {\n            files {\n              id\n              name\n            }\n          }\n        }\n      }\n    }\n  }\n}\n    "])));
/**
 * __useGetMeetingServiceRequestsForEventBySpaceIdQuery__
 *
 * To run a query within a React component, call `useGetMeetingServiceRequestsForEventBySpaceIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMeetingServiceRequestsForEventBySpaceIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMeetingServiceRequestsForEventBySpaceIdQuery({
 *   variables: {
 *      spaceId: // value for 'spaceId'
 *      eventInstance: // value for 'eventInstance'
 *   },
 * });
 */
export function useGetMeetingServiceRequestsForEventBySpaceIdQuery(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useQuery(GetMeetingServiceRequestsForEventBySpaceIdDocument, options);
}
export function useGetMeetingServiceRequestsForEventBySpaceIdLazyQuery(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useLazyQuery(GetMeetingServiceRequestsForEventBySpaceIdDocument, options);
}
export var GetSpaceByIdForDraftEventMeetingServicePermissionDocument = gql(templateObject_10 || (templateObject_10 = __makeTemplateObject(["\n    query GetSpaceByIdForDraftEventMeetingServicePermission($spaceId: ID!) {\n  getSpaceById(id: $spaceId) {\n    id\n    scheduleConfiguration\n    requestForm {\n      id\n      name\n    }\n    permissions {\n      name\n      value\n    }\n  }\n}\n    "], ["\n    query GetSpaceByIdForDraftEventMeetingServicePermission($spaceId: ID!) {\n  getSpaceById(id: $spaceId) {\n    id\n    scheduleConfiguration\n    requestForm {\n      id\n      name\n    }\n    permissions {\n      name\n      value\n    }\n  }\n}\n    "])));
/**
 * __useGetSpaceByIdForDraftEventMeetingServicePermissionQuery__
 *
 * To run a query within a React component, call `useGetSpaceByIdForDraftEventMeetingServicePermissionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSpaceByIdForDraftEventMeetingServicePermissionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSpaceByIdForDraftEventMeetingServicePermissionQuery({
 *   variables: {
 *      spaceId: // value for 'spaceId'
 *   },
 * });
 */
export function useGetSpaceByIdForDraftEventMeetingServicePermissionQuery(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useQuery(GetSpaceByIdForDraftEventMeetingServicePermissionDocument, options);
}
export function useGetSpaceByIdForDraftEventMeetingServicePermissionLazyQuery(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useLazyQuery(GetSpaceByIdForDraftEventMeetingServicePermissionDocument, options);
}
export var GetSpacesByIdsDocument = gql(templateObject_11 || (templateObject_11 = __makeTemplateObject(["\n    query GetSpacesByIds($ids: [ID!]!) {\n  getSpacesByIds(ids: $ids) {\n    id\n    image\n    locationId\n    levelId\n    name\n    description\n    capacity\n    isManaged\n    calendar {\n      calendarId\n      createdAt\n      remoteType\n      spaceId\n      spaceResourceEmail\n      spaceResourceId\n      subscriberExpiresAt\n      subscriberId\n    }\n    permissions {\n      name\n      value\n    }\n    amenities {\n      id\n      quantity\n      amenityId\n      name\n    }\n    scheduleConfiguration\n  }\n}\n    "], ["\n    query GetSpacesByIds($ids: [ID!]!) {\n  getSpacesByIds(ids: $ids) {\n    id\n    image\n    locationId\n    levelId\n    name\n    description\n    capacity\n    isManaged\n    calendar {\n      calendarId\n      createdAt\n      remoteType\n      spaceId\n      spaceResourceEmail\n      spaceResourceId\n      subscriberExpiresAt\n      subscriberId\n    }\n    permissions {\n      name\n      value\n    }\n    amenities {\n      id\n      quantity\n      amenityId\n      name\n    }\n    scheduleConfiguration\n  }\n}\n    "])));
/**
 * __useGetSpacesByIdsQuery__
 *
 * To run a query within a React component, call `useGetSpacesByIdsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSpacesByIdsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSpacesByIdsQuery({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useGetSpacesByIdsQuery(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useQuery(GetSpacesByIdsDocument, options);
}
export function useGetSpacesByIdsLazyQuery(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useLazyQuery(GetSpacesByIdsDocument, options);
}
export var LocationDetailsDocument = gql(templateObject_12 || (templateObject_12 = __makeTemplateObject(["\n    query LocationDetails($locationIds: [ID!]!) {\n  getLocationsByIds(ids: $locationIds) {\n    id\n    name\n    levels {\n      id\n      name\n    }\n  }\n}\n    "], ["\n    query LocationDetails($locationIds: [ID!]!) {\n  getLocationsByIds(ids: $locationIds) {\n    id\n    name\n    levels {\n      id\n      name\n    }\n  }\n}\n    "])));
/**
 * __useLocationDetailsQuery__
 *
 * To run a query within a React component, call `useLocationDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useLocationDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLocationDetailsQuery({
 *   variables: {
 *      locationIds: // value for 'locationIds'
 *   },
 * });
 */
export function useLocationDetailsQuery(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useQuery(LocationDetailsDocument, options);
}
export function useLocationDetailsLazyQuery(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useLazyQuery(LocationDetailsDocument, options);
}
export var LocationDetailByIdDocument = gql(templateObject_13 || (templateObject_13 = __makeTemplateObject(["\n    query LocationDetailById($locationId: ID!) {\n  getLocationById(id: $locationId) {\n    id\n    name\n    levels {\n      id\n      name\n      totalSpaces\n    }\n  }\n}\n    "], ["\n    query LocationDetailById($locationId: ID!) {\n  getLocationById(id: $locationId) {\n    id\n    name\n    levels {\n      id\n      name\n      totalSpaces\n    }\n  }\n}\n    "])));
/**
 * __useLocationDetailByIdQuery__
 *
 * To run a query within a React component, call `useLocationDetailByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useLocationDetailByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLocationDetailByIdQuery({
 *   variables: {
 *      locationId: // value for 'locationId'
 *   },
 * });
 */
export function useLocationDetailByIdQuery(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useQuery(LocationDetailByIdDocument, options);
}
export function useLocationDetailByIdLazyQuery(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useLazyQuery(LocationDetailByIdDocument, options);
}
export var GetLevelByIdDocument = gql(templateObject_14 || (templateObject_14 = __makeTemplateObject(["\n    query GetLevelById($levelId: ID!) {\n  getLevelById(id: $levelId) {\n    id\n    levelLocation {\n      id\n    }\n  }\n}\n    "], ["\n    query GetLevelById($levelId: ID!) {\n  getLevelById(id: $levelId) {\n    id\n    levelLocation {\n      id\n    }\n  }\n}\n    "])));
/**
 * __useGetLevelByIdQuery__
 *
 * To run a query within a React component, call `useGetLevelByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLevelByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLevelByIdQuery({
 *   variables: {
 *      levelId: // value for 'levelId'
 *   },
 * });
 */
export function useGetLevelByIdQuery(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useQuery(GetLevelByIdDocument, options);
}
export function useGetLevelByIdLazyQuery(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useLazyQuery(GetLevelByIdDocument, options);
}
export var DeleteOrCancelMeetingServiceRequestDocument = gql(templateObject_15 || (templateObject_15 = __makeTemplateObject(["\n    mutation DeleteOrCancelMeetingServiceRequest($meetingServiceRequestId: ID!) {\n  deleteOrCancelMeetingServiceRequest(\n    meetingServiceRequestId: $meetingServiceRequestId\n  )\n}\n    "], ["\n    mutation DeleteOrCancelMeetingServiceRequest($meetingServiceRequestId: ID!) {\n  deleteOrCancelMeetingServiceRequest(\n    meetingServiceRequestId: $meetingServiceRequestId\n  )\n}\n    "])));
/**
 * __useDeleteOrCancelMeetingServiceRequestMutation__
 *
 * To run a mutation, you first call `useDeleteOrCancelMeetingServiceRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteOrCancelMeetingServiceRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteOrCancelMeetingServiceRequestMutation, { data, loading, error }] = useDeleteOrCancelMeetingServiceRequestMutation({
 *   variables: {
 *      meetingServiceRequestId: // value for 'meetingServiceRequestId'
 *   },
 * });
 */
export function useDeleteOrCancelMeetingServiceRequestMutation(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useMutation(DeleteOrCancelMeetingServiceRequestDocument, options);
}
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12, templateObject_13, templateObject_14, templateObject_15;
